import { useState } from "react";
import { useSelector } from "react-redux";

const useSelectOptions = () => {
  const [selectOptions, setSelectOptions] = useState([]);
  const data = useSelector((state) => state.dataTable.data);

  for (const key in data[0]) {
    if (data[0].hasOwnProperty(key)) {
      const value = data[0][key];
      if (!value) continue;
      if (!selectOptions.some((option) => option.key === key)) {
        setSelectOptions([
          ...selectOptions,
          { key, value: key + " - " + value },
        ]);
      }
    }
  }

  selectOptions.sort((a, b) => {
    return a.key.localeCompare(b.key);
  });

  return { selectOptions };
};

export default useSelectOptions;
